import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
    Button,
    CustomInput,
    Badge
} from "reactstrap";
import _ from "lodash";
import { useFetch2 } from "components/utils/authenticatedHook";
import Select from "react-select";
import RequiredSelect from "./RequiredSelect";
import moment from "moment-timezone";
import SweetAlert from "react-bootstrap-sweetalert";
import QuestionList from "./questionList";
import Header from "./Header";
import { QuestionIcon } from "./ruleIcon";
import { Field, FieldArray, Formik } from "formik";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { filteredTimezones } from "../../constants/general.constant";

function CreateEducationQuestionnaire(props) {
    const history = props.history;
    let [{ response: educationMaterial, error: educationMaterialError, isLoading: educationMaterialLoader }, doFetch] = useFetch2();
    let [{ response: createEducationMaterialQuestion, error: educationMaterialQuestionError, isLoading: educationMaterialQuestionLoader }, doFetch2] = useFetch2();
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isDeleteKey, setIsDeleteKey] = useState(undefined);
    const [questionModal, SetQuestionModal] = useState(false);
    const [questionData, SetQuestionData] = useState([]);
    const [questionError, setQuestionError] = useState("");
    const [initialValues, setInitialValues] = useState({
        is_edit_key: "",
        question: "",
        answers: [
            { answer: "", isCurrectAnswer: false },
            { answer: "", isCurrectAnswer: false },
        ],
    });
    const [formData, setFormData] = useState({
        timezone: "",
        name: "",
        condition: "",
        notifyStaff: [],
        notifySelf: [],
        materialType: "",
        messageCareprovider: "",
        patient: "",
        repeatPer: "",
        timeDuration: "",
        startDate: "",
        endDate: ""
    });
    const [timeDurationError, setTimeDurationError] = useState("");
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");

    const { userDetails } = useSelector(state => state.user);
    useEffect(() => {
        doFetch({
            url: "/get-education-material-type",
            method: "GET",
            disableWait: true,
        });
    }, [])
    const handleTimezone = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            timezone: selectedOption,
        }));
    };
    const handleMaterialType = (event) => {
        setFormData((prev) => ({
            ...prev, materialType: event,
        }));
    }
    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.value;

        const name = target.name;
        const notifySelf = formData.notifySelf;
        const notifyStaff = formData.notifyStaff;

        if (target.type === "checkbox") {
            let index;
            if (target.checked) {
                // add the numerical value of the checkbox to options array
                if (name === "notifySelf") {
                    notifySelf.push(event.target.value);
                } else if (name === "notifyStaff") {
                    notifyStaff.push(event.target.value);
                }
            } else {
                // or remove the value from the unchecked checkbox from the array
                if (name === "notifySelf") {
                    index = notifySelf.indexOf(event.target.value);
                    notifySelf.splice(index, 1);
                } else if (name === "notifyStaff") {
                    index = notifyStaff.indexOf(event.target.value);
                    notifyStaff.splice(index, 1);
                }
            }
            setFormData((prev) => ({
                ...prev,
                notifySelf: notifySelf,
                notifyStaff: notifyStaff,
            }));
            return;
        }
        setFormData((prev) => ({
            ...prev, [name]: value,
        }));
    }
    const model = (key = "") => {
        SetQuestionModal(!questionModal);
        if (key !== "" && questionData[key]) {
            let answerValue = questionData[key];
            if (answerValue) {
                answerValue.is_edit_key = key;
                setInitialValues(answerValue);
            }
        } else {
            setInitialValues({
                is_edit_key: "",
                question: "",
                answers: [
                    { answer: "", isCurrectAnswer: false },
                    { answer: "", isCurrectAnswer: false },
                ],
            });
        }
    }
    const removeQuestion = (key) => {
        let questionDataUpdated = questionData;
        var selectedIndex = isDeleteKey;
        questionDataUpdated.splice(selectedIndex, 1);
        SetQuestionData(questionDataUpdated);
        setIsDelete(false);
    }
    const QuestionIsDelete = (key) => {
        setIsDelete(true);
        setIsDeleteKey(key);
    }
    const cancelDelete = () => {
        setIsDelete(false);
    }
    const handleChangePatient = (event) => {
        setFormData((prev) => ({ ...prev, patient: event }));
    }
    const handleConditions = (selectedOption) => {
        setFormData((prev) => ({
            ...prev, condition: selectedOption
        }));
    };
    const handleRepetedCondition = (selectedOption) => {
        setFormData((prev) => ({
            ...prev, repeatPer: selectedOption.value,
        }));
        if(selectedOption && selectedOption.value){
            setFormData((prev) => ({...prev, timeDuration: 'noEndDate'}))
        }
        setTimeDurationError("")
    }
    const handleRadioChange = (e) => {
        const value = e.target?.value;
        setFormData((prev) => ({
            ...prev, timeDuration: value,
        }))
        setTimeDurationError("")
    };

    const handleInputDateChange = (e) => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const formattedValue = moment(value).format("YYYY-MM-DD");

        setFormData((prev) => ({
            ...prev,
            [name]: formattedValue,
        }));
        if(formData.repeatPer === "once"){
        setFormData((prev) => ({
            ...prev,
            endDate: formattedValue,
        }));
        }
        // Clear existing errors
        setStartDateError('');
        setEndDateError('');

        // Defer validation until state update completes
        setTimeout(() => {
            validateDates(name === 'startDate' ? formattedValue : formData.startDate,
                (name === 'endDate' || formData.repeatPer === "once")  ? formattedValue : formData.endDate);
        }, 0);
    };

    const validateDates = (startDate, endDate) => {
        if (formData.timeDuration !== 'byDate') return true;

        let isValid = true;

        // Validate empty dates
        if (!startDate) {
            setStartDateError('Please select a start date.');
            isValid = false;
        }

        if (!endDate) {
            setEndDateError('Please select an end date.');
            isValid = false;
        }

        if (startDate && endDate) {
            const start = moment(startDate, 'YYYY-MM-DD').startOf("day");;
            const end = moment(endDate, 'YYYY-MM-DD').endOf("day");

            if (end.isBefore(start)) {
                setEndDateError('End date must be greater than or equal to start date.');
                isValid = false;
            }
        }

        return isValid;
    };

    const validate = (values) => {
        const errors = {};
        if (!values.question) {
            errors.question = "Question is Required";
        }
        var status = _.filter(values.answers, function (item) {
            return item.isCurrectAnswer === true;
        });
        if (status.length == 0) {
            errors.isCurrectAnswer = "At least one correct answer must be selected.";
        }
        // check duplicate answers added
        let duplicateOption = false;
        if (values && values.answers && values.answers.length) {
            // Filter out the duplicates
            _.map(values.answers, (item, index, self) => {
                const findDuplicate = _.filter(values.answers, (element, i) => i != index && element.answer.toLowerCase().replace(/\s+/g, '').trim() == item.answer.toLowerCase().replace(/\s+/g, '').trim())
                if (findDuplicate && findDuplicate.length > 0) {
                    duplicateOption = true;
                }
            });
            if (duplicateOption) {
                errors.isCurrectAnswer = "You cannot select the same option more than once.";
            }
        }
        // check duplicate question added
        let duplicateQuestion = false;
        if (questionData && questionData.length > 0) {
            // Filter out the duplicates
            _.map(questionData, (item) => {
                const findQuestion = values.question.toLowerCase().replace(/\s+/g, '').trim() == item.question.toLowerCase().replace(/\s+/g, '').trim()
                if (findQuestion && values.is_edit_key !== item.is_edit_key) {
                    duplicateQuestion = true;
                }
            });
            if (duplicateQuestion) {
                errors.isCurrectAnswer = "You are not allowed to add the same question more than once.";
            }
        }
        const data2 = Array.from(document.getElementsByClassName(`option-value`));
        data2.map((e, index) => {
            let checkValueLength = e.value.trim().length;
            if (checkValueLength === 0) {
                if (!errors.answers) errors.answers = [];
                errors.answers[index] = {
                    answer: "Option Value is Required",
                };
            }
        });
        return errors;
    };
    const handleSubmit = (values, resetForm) => {
        let arr = questionData;
        if (values.is_edit_key !== "") {
            const obj = arr[values.is_edit_key];
            const question = values.question;
            const answers = values.answers;
            if(question){
             delete obj.question;
            }
            if(answers){
             delete obj.answers;
            }
            arr[values.is_edit_key] = {
                question: question,
                answers: answers,
                ...obj
            };
        } else {
            arr.push({
                question: values.question,
                answers: values.answers,
            });
        }
        SetQuestionData(arr);
        SetQuestionModal(false);
        setQuestionError("");
    };

    async function onSubmit(event) {
        event.preventDefault();
        setIsFormSubmitted(true);
        if (isFormSubmitted && (!formData.timezone || _.isEmpty(formData.name) || _.isEmpty(formData.repeatPer) || (_.isEmpty(formData.messageCareprovider) && (formData.notifySelf.length > 0 || formData.notifyStaff.length > 0)))) {
            if (!formData.timeDuration) {
                setTimeDurationError("You have to select at least one time duration")
            } else {
                setTimeDurationError("")
            }
            return;
        }
        if (!formData.timeDuration) {
            setTimeDurationError("You have to select at least one time duration")
            return false;
        } else {
            setTimeDurationError("")
        }
        if (formData.timeDuration && (formData.timeDuration === 'byDate') && formData.startDate === "") {
            setStartDateError("You have to select start date");
            return false;
        }
        if (!_.isEmpty(startDateError) || !_.isEmpty(endDateError)) {
            return;
        }
        if (questionData.length === 0) {
            let message = "There should be more than one question.";
            setQuestionError(message);
            return false;
        }
        if ((formData.notifyStaff.length > 0 ||
            formData.notifySelf.length > 0) && formData.messageCareprovider?.trim().length === 0) {
            toast.error(
                "A notification is checked in notify me/staff, please provide a message for the care prodiver/Staff"
            );
            return false;
        }
        const timeZone = formData.timezone && formData.timezone.value ? formData.timezone.value : 'America/New_York';
        const payload = {
            educationMaterialType: formData.materialType ? formData.materialType._id : "",
            messageCareprovider: formData?.messageCareprovider,
            notifySelf: formData?.notifySelf,
            notifyStaff: formData?.notifyStaff,
            name: formData?.name,
            timezone: timeZone,
            createdBy: userDetails && userDetails._id ? userDetails._id : '',
            questions: questionData,
            repeatPer: formData.repeatPer,
            timeDuration: formData.timeDuration,
            startDate: formData.startDate ? moment(formData.startDate).tz(timeZone).format() : "",
            endDate: formData.endDate ? moment(formData.endDate).tz(timeZone).format() : ""
        }
        if (formData.condition && formData.condition.length > 0) {
            payload.conditionGroup = formData.condition.map(item => item._id)
        }
        if (formData.patient && formData.patient.length > 0) {
            payload.sharedUsers = formData.patient.map(patient => patient._id)
        }
        doFetch2({
            url: "/create-education-material-questions",
            method: "POST",
            disableWait: true,
            body: payload
        })
    }
    useEffect(() => {
        if (educationMaterialQuestionLoader && isFormSubmitted) {
            setIsFormSubmitted(false);
            setFormData({
                timezone: "",
                name: "",
                condition: "",
                notifyStaff: [],
                notifySelf: [],
                materialType: "",
                messageCareprovider: "",
                patient: "",
                repeatPer: "",
                timeDuration: "",
                startDate: "",
                endDate: ""
            })
            setQuestionError("")
            SetQuestionData([])
            setInitialValues({
                is_edit_key: "",
                question: "",
                answers: [
                    { answer: "", isCurrectAnswer: false },
                    { answer: "", isCurrectAnswer: false },
                ],
            })
            history.push("/questionnaire");

        }
    }, [educationMaterialQuestionLoader])
    return (
        <div>
            <Header
                backbutton="d-flex"
                mainbutton="d-none"
                title="Create New Vitals Monitoring"
            >
                <img
                    src={QuestionIcon}
                    className="mr-2"
                    style={{ width: "40px", height: "40px" }}
                    alt="image"
                />
            </Header>
            <div className="row">
                <div className="col-12 grid-margin">
                    <div className="card">
                        <div className="card-body project-tab pt-2 mt-4">
                            <Form onSubmit={onSubmit}>
                                <FormGroup>
                                    <Label for="exampleSelect">Select a Timezone</Label>
                                    <RequiredSelect
                                        SelectComponent={Select}
                                        value={formData.timezone} // should be an object: { label, value }
                                        onChange={handleTimezone}
                                        options={filteredTimezones}
                                        name="timezone"
                                    />
                                    <span>
                                        {(formData && !formData.timezone && isFormSubmitted) ? (
                                            <div className="input-feedback">
                                                Timezone is required
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleSelect">Select a Education Material Type</Label>
                                    <RequiredSelect
                                        SelectComponent={Select}
                                        value={formData.materialType}
                                        onChange={handleMaterialType}
                                        options={
                                            educationMaterial && educationMaterial.educationMaterialType
                                                ? educationMaterial.educationMaterialType
                                                : []
                                        }
                                        isMulti={false}
                                        getOptionLabel={(option) => option["materialType"]}
                                        getOptionValue={(option) => option}
                                        name="materialType"
                                        isLoading={educationMaterialLoader}
                                        isDisabled={educationMaterialLoader}
                                    />
                                    <span>
                                        {(formData && !formData.materialType && isFormSubmitted) ? (
                                            <div className="input-feedback">
                                                Education material type is required
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleEmail">Questionnaire Title </Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        id="exampleEmail"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        placeholder="Questionnaire Title"
                                        className="question-input-field input-date-filter"
                                    />
                                    <span>
                                        {(formData && isFormSubmitted && !formData.name && _.isEmpty(formData.name)) ? (
                                            <div className="input-feedback">
                                                Questionnaire title is required
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="exampleSelect">Select Frequency</Label>
                                            <RequiredSelect
                                                SelectComponent={Select}
                                                value={[
                                                    { value: "once", label: "Once" },
                                                    { value: "day", label: "Daily" },
                                                    {
                                                        value: "everyOtherDay",
                                                        label: "Every Other Day",
                                                    },
                                                    { value: "week", label: "Week" },
                                                    { value: "month", label: "Month" },
                                                ].filter(
                                                    ({ value }) => value === formData.repeatPer
                                                )}
                                                onChange={handleRepetedCondition}
                                                options={[
                                                    { value: "once", label: "Once" },
                                                    { value: "day", label: "Daily" },
                                                    {
                                                        value: "everyOtherDay",
                                                        label: "Every Other Day",
                                                    },
                                                    { value: "week", label: "Week" },
                                                    { value: "month", label: "Month" },
                                                ]}
                                            />
                                            <span>
                                                {(formData && isFormSubmitted && !formData.repeatPer && _.isEmpty(formData.repeatPer)) ? (
                                                    <div className="input-feedback">
                                                        Frequency is required
                                                    </div>
                                                ) : null}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    {formData.repeatPer !== "once" && <Col lg={4} md={6} sm={12} xs={12} className="p-2">
                                        <FormGroup>
                                            <Label for="exampleSelect">Select Time Duration</Label>
                                            <div className="radio-group">
                                                <Label>
                                                    <Input
                                                        name="timeDuration"
                                                        type="radio"
                                                        value="byDate"
                                                        onChange={handleRadioChange}
                                                        className="radio-questionnarie-input"
                                                        checked={formData.timeDuration === "byDate"}
                                                    />
                                                    <span className="radio-questionnarie-text">By Date</span>
                                                </Label>
                                                <Label>
                                                    <Input
                                                        name="timeDuration"
                                                        type="radio"
                                                        value="noEndDate"
                                                        onChange={handleRadioChange}
                                                        className="radio-questionnarie-input"
                                                        checked={formData.timeDuration === "noEndDate"}
                                                    />
                                                    <span className="radio-questionnarie-text">No End Date</span>
                                                </Label>
                                            </div>
                                            <span>
                                                {timeDurationError !== "" ? (
                                                    <div className="input-feedback">
                                                        {timeDurationError}
                                                    </div>
                                                ) : null}
                                            </span>
                                        </FormGroup>
                                    </Col>}
                                    {(formData.timeDuration === 'byDate') && (
                                        <Col lg={4} md={6} sm={12} xs={12} className="p-2">
                                            <FormGroup className="remove-bottom-margin form-group-patient">
                                                <Label for="exampleStartDate">Start Date:</Label>
                                                <Input
                                                    className="input-date-filter remove-bottom-margin"
                                                    type="date"
                                                    name="startDate"
                                                    min={moment().format("YYYY-MM-DD")}
                                                    onChange={handleInputDateChange}
                                                    value={formData.startDate}
                                                    style={{ "min-height": "56px" }}
                                                />
                                                <span>
                                                    {startDateError !== "" ? (
                                                        <div className="input-feedback">
                                                            {startDateError}
                                                        </div>
                                                    ) : null}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    )}
                                    {(formData.timeDuration === 'byDate' && formData.repeatPer !== "once") && (
                                        <Col lg={4} md={6} sm={12} xs={12} className="p-2">
                                            <FormGroup className="remove-bottom-margin form-group-patient">
                                                <Label for="exampleEndDate">End Date:</Label>
                                                <Input
                                                    className="input-date-filter remove-bottom-margin pd-4"
                                                    type="date"
                                                    name="endDate"
                                                    min={moment().format("YYYY-MM-DD")}
                                                    onChange={handleInputDateChange}
                                                    value={formData.endDate}
                                                    style={{ "min-height": "56px" }}
                                                />
                                                <span>
                                                    {endDateError !== "" ? (
                                                        <div className="input-feedback">
                                                            {endDateError}
                                                        </div>
                                                    ) : null}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    )}
                                </Row>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            {/* <div className="col-12" style={{ padding: 0 }}> */}
                                            <Label for="exampleEmail" style={{ lineHeight: 3 }}>
                                                Questions
                                            </Label>
                                            <Button
                                                className="float-right text-white"
                                                color="danger"
                                                size="sm"
                                                style={{ alignItems: "flex-end", borderRadius: 7 }}
                                                onClick={model}
                                            >
                                                Add Question
                                            </Button>
                                            {/* </div> */}
                                            <QuestionList
                                                actions={[
                                                    { click: model, label: "Edit" },
                                                    { click: QuestionIsDelete, label: "Delete" },
                                                ]}
                                                question_list={questionData}
                                            />
                                            <SweetAlert
                                                title="Are you sure?"
                                                warning
                                                showCancel={true}
                                                show={isDelete}
                                                confirmBtnText="Yes, delete it!"
                                                confirmBtnBsStyle="danger"
                                                cancelBtnBsStyle="default"
                                                onConfirm={removeQuestion}
                                                onCancel={cancelDelete}
                                            >
                                                Your Question is Not Show After Delete
                                            </SweetAlert>
                                            <span style={{ padding: 7, fontSize: 15 }}>
                                                {questionError !== "" ? (
                                                    <div className="input-feedback">
                                                        {questionError}
                                                    </div>
                                                ) : null}
                                            </span>
                                        </FormGroup>
                                </Col>
                                </Row>
                                <FormGroup>
                                    <Label for="exampleText">
                                        Notification Message (Careprovider)
                                    </Label>
                                    <Input
                                        type="textarea"
                                        name="messageCareprovider"
                                        onChange={handleInputChange}
                                        rows={10}
                                        className="input-date-filter"
                                        value={formData.messageCareprovider}
                                    />
                                    <span>
                                        {(formData && isFormSubmitted && !formData.messageCareprovider && _.isEmpty(formData.messageCareprovider) && (formData.notifySelf.length > 0 || formData.notifyStaff.length > 0)) ? (
                                            <div className="input-feedback">
                                                Notification message is required
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        Select a Condition to Monitor
                                    </Label>
                                    <RequiredSelect
                                        SelectComponent={Select}
                                        required={false}
                                        value={formData.condition}
                                        onChange={handleConditions}
                                        options={
                                            educationMaterial && educationMaterial.condition
                                                ? educationMaterial.condition
                                                : []
                                        }
                                        isMulti={true}
                                        getOptionLabel={(option) => option["condition"]}
                                        getOptionValue={(option) => option._id}
                                        name="condition"
                                        isLoading={educationMaterialLoader}
                                        isDisabled={educationMaterialLoader}
                                    />
                                    <span>
                                        {(formData && isFormSubmitted && (formData.patient.length === 0 && formData.condition.length === 0)) ? (
                                            <div className="input-feedback">
                                                Please select at least one condition
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        Select a Patient to Monitor
                                    </Label>
                                    <RequiredSelect
                                        SelectComponent={Select}
                                        value={formData.patient}
                                        onChange={handleChangePatient}
                                        options={
                                            educationMaterial && educationMaterial.patients
                                                ? educationMaterial.patients
                                                : []
                                        }
                                        isMulti={true}
                                        getOptionLabel={(option) =>
                                            option["fname"] + " " + option["lname"]
                                        }
                                        getOptionValue={(option) => option._id}
                                        name="patient"
                                    />
                                    <span>
                                        {(formData && isFormSubmitted && (formData.patient.length === 0 && formData.condition.length === 0)) ? (
                                            <div className="input-feedback">
                                                Please select at least one patient
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleCheckbox">Notify Careprovider</Label>
                                    <div>
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline"
                                            name="notifySelf"
                                            onChange={handleInputChange}
                                            value="inbox"
                                            label="Inbox"
                                            inline
                                            checked={formData.notifySelf.includes("inbox")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline2"
                                            name="notifySelf"
                                            onChange={handleInputChange}
                                            label="SMS"
                                            value="sms"
                                            inline
                                            checked={formData.notifySelf.includes("sms")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline3"
                                            name="notifySelf"
                                            onChange={handleInputChange}
                                            label="VOICE"
                                            value="voice"
                                            inline
                                            checked={formData.notifySelf.includes("voice")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline4"
                                            name="notifySelf"
                                            onChange={handleInputChange}
                                            label="EMAIL"
                                            value="email"
                                            inline
                                            checked={formData.notifySelf.includes("email")}
                                        />
                                    </div>
                                    <span>
                                        {(formData && isFormSubmitted && formData.messageCareprovider && !_.isEmpty(formData.messageCareprovider) && (formData.notifySelf.length === 0 && formData.notifyStaff.length === 0)) ? (
                                            <div className="input-feedback">
                                                Please select one notification method (SMS, Voice, or Email)
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleCheckbox">Notify Staff</Label>
                                    <div>
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline10"
                                            name="notifyStaff"
                                            onChange={handleInputChange}
                                            value="inbox"
                                            label="Inbox"
                                            inline
                                            checked={formData.notifyStaff.includes("inbox")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline11"
                                            name="notifyStaff"
                                            onChange={handleInputChange}
                                            label="SMS"
                                            value="sms"
                                            inline
                                            checked={formData.notifyStaff.includes("sms")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline12"
                                            name="notifyStaff"
                                            onChange={handleInputChange}
                                            label="VOICE"
                                            value="voice"
                                            inline
                                            checked={formData.notifyStaff.includes("voice")}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            id="exampleCustomInline13"
                                            name="notifyStaff"
                                            onChange={handleInputChange}
                                            label="EMAIL"
                                            value="email"
                                            inline
                                            checked={formData.notifyStaff.includes("email")}
                                        />
                                    </div>
                                    <span>
                                        {(formData && isFormSubmitted && formData.messageCareprovider && !_.isEmpty(formData.messageCareprovider) && (formData.notifySelf.length === 0 && formData.notifyStaff.length === 0)) ? (
                                            <div className="input-feedback">
                                                Please select one notification method (SMS, Voice, or Email)
                                            </div>
                                        ) : null}
                                    </span>
                                </FormGroup>

                                <Button
                                    type="submit"
                                    className="btn btn-info btn-lg btn-block px-10"
                                    disabled={educationMaterialQuestionLoader}
                                >
                                    {educationMaterialQuestionLoader ? <i className="mdi mdi-loading mdi-spin mr-2" /> : <i className="mdi  mdi-content-save" />} Submit
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Question add modal */}
            <Modal isOpen={questionModal} toggle={model}>
                <ModalHeader toggle={model}>Add Question</ModalHeader>
                <ModalBody>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validate={(values) => validate(values)}
                        onSubmit={(values, { resetForm }) =>
                            handleSubmit(values, resetForm)
                        }
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                        }) => {
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <Label
                                            style={{
                                                fontSize: 17,
                                            }}
                                        >
                                            Question
                                        </Label>
                                        <Input
                                            type="text"
                                            name="question"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.question}
                                            placeholder="Enter question"
                                            style={{ borderRadius: 7 }}
                                        />
                                        {errors.question && touched.question && (
                                            <div className="input-feedback">
                                                {errors.question}
                                            </div>
                                        )}
                                    </FormGroup>
                                    <Row>
                                        <Col lg={12} md={12} xs={12}>
                                            <FieldArray
                                                name="answers"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        {values.answers && values.answers.length > 0
                                                            ? values.answers.map((answers, index) => {
                                                                const option_valueErrors =
                                                                    (errors.answers?.length &&
                                                                        errors.answers[index]?.answer) ||
                                                                    "";
                                                                const option_valueTouched =
                                                                    (touched.answers?.length &&
                                                                        touched.answers[index]?.answer) ||
                                                                    "";
                                                                return (
                                                                    <>
                                                                        <div key={"answer-" + index}>
                                                                            <Row>
                                                                                <Col lg={12}>
                                                                                    <FormGroup>
                                                                                        <Label
                                                                                            style={{
                                                                                                fontSize: 17,
                                                                                            }}
                                                                                        >
                                                                                            Option
                                                                                        </Label>
                                                                                        <div>
                                                                                            <Row>
                                                                                                <Col lg={8} md={8} sm={12} xs={12}>
                                                                                                    <Field
                                                                                                        name={`answers.${index}.answer`}
                                                                                                        placeholder={
                                                                                                            "Enter option"
                                                                                                        }
                                                                                                        type="text"
                                                                                                        className={
                                                                                                            "form-control form-field option-value " +
                                                                                                            (option_valueTouched &&
                                                                                                                option_valueErrors
                                                                                                                ? " form-field-error"
                                                                                                                : option_valueTouched &&
                                                                                                                    !option_valueErrors
                                                                                                                    ? " form-field-success"
                                                                                                                    : "")
                                                                                                        }
                                                                                                        // value={answers.answer}
                                                                                                        onChange={
                                                                                                            handleChange
                                                                                                        }
                                                                                                        handleBlur={
                                                                                                            handleBlur
                                                                                                        }
                                                                                                    />
                                                                                                    <span>
                                                                                                        {option_valueTouched &&
                                                                                                            option_valueErrors ? (
                                                                                                            <div className="input-feedback">
                                                                                                                {
                                                                                                                    option_valueErrors
                                                                                                                }
                                                                                                            </div>
                                                                                                        ) : null}
                                                                                                    </span>
                                                                                                </Col>
                                                                                                <Col
                                                                                                    lg={4}
                                                                                                    md={4}
                                                                                                    sm={12}
                                                                                                    xs={12}
                                                                                                    className="d-flex"
                                                                                                >
                                                                                                    <CustomInput
                                                                                                        className="custom-correct-checkbox"
                                                                                                        type="checkbox"
                                                                                                        onChange={
                                                                                                            handleChange
                                                                                                        }
                                                                                                        onBlur={handleBlur}
                                                                                                        // value={
                                                                                                        //     answers.isCurrectAnswer
                                                                                                        // }
                                                                                                        checked={
                                                                                                            answers.isCurrectAnswer
                                                                                                        }
                                                                                                        id={`answers.${index}.isCurrectAnswer`}
                                                                                                        name={`answers.${index}.isCurrectAnswer`}
                                                                                                        label="Is correct"
                                                                                                        inline
                                                                                                    />
                                                                                                    {index >= 2 && (
                                                                                                        <Badge
                                                                                                            style={{
                                                                                                                cursor: "pointer",
                                                                                                                fontSize: 13,
                                                                                                                borderRadius: 7,
                                                                                                                width: 32,
                                                                                                                height: 32,
                                                                                                            }}
                                                                                                            className="m-1 p-2"
                                                                                                            color="danger"
                                                                                                            pill
                                                                                                            onClick={() =>
                                                                                                                arrayHelpers.remove(
                                                                                                                    index
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            X
                                                                                                        </Badge>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </FormGroup>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                            : ""}
                                                        <Button
                                                            size="sm"
                                                            style={{ borderRadius: 7 }}
                                                            className={"secondary-add-button"}
                                                            onClick={() =>
                                                                arrayHelpers.push({
                                                                    answer: "",
                                                                    isCurrectAnswer: false,
                                                                })
                                                            }
                                                        >
                                                            Add
                                                        </Button>
                                                        <div className="input-feedback">
                                                            {errors.isCurrectAnswer ? (
                                                                <div> Note : {errors.isCurrectAnswer}</div>
                                                            ) : null}
                                                            {errors.duplicatesOption ? (
                                                                <div> Note : {errors.duplicatesOption}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-info"
                                        value="Submit"
                                        disabled={isSubmitting}
                                    >
                                        Save
                                    </button>
                                </Form>
                            );
                        }}
                    </Formik>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default withRouter(CreateEducationQuestionnaire);